import { render } from "./ProductSettingsSection.vue?vue&type=template&id=7b995d5d"
import script from "./ProductSettingsSection.vue?vue&type=script&lang=js"
export * from "./ProductSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__